// Set up your root reducer here...
import { combineReducers } from 'redux';
import imeiSearch from './imeiSearchReducer';

const rootRdeucer = combineReducers({
  imeiSearch,
});

export default rootRdeucer;
